import crud from './crud'
import scopes from './scopes'

export default {
    namespaced: true,
    state: {
        ...crud.state,
        ...scopes.state,
    },
    mutations: {
        ...crud.mutations,
        ...scopes.mutations
    },
    actions: {
        ...crud.actions,
        ...scopes.actions
    }
}